import AppRouter from './router'
import ToastService from './shared/components/ToastService'

export default function App() {
  
  return (
    <>
      <AppRouter />
      <ToastService />
    </>
  )
}
